import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MeetingCameraIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/base-components';
import useRenewClientToken from '@rsos/hooks/videoTo911/useRenewClientToken';
import useSelectedVideoRoom from '@rsos/hooks/videoTo911/useSelectedVideoRoom';
import {
  LIVE_VIDEO_CARD,
  closeCard,
} from '@rsos/reduxDataStore/src/features/mapCard/mapCardSlice';
import { useSelectedTextFrom911Conversation } from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Selectors';
import useIsVT911Enabled from '../../../../../hooks/useIsVT911Enabled';
import { LiveVideoButton } from '../../TF911ChatBox/TF911.styles';
import { useVideoSessionInitialization } from '../useVideoSessionInitialization/useVideoSessionInitializationLegacy';

export const LiveVideoButtonContainerLegacy = ({
  onStartConversation,
  isForOverview = false,
}) => {
  const dispatch = useDispatch();
  const selectedCallerId = useSelector(
    state => state.emergencyCalls.selectedCallerID,
  );

  const isVT911Enabled = useIsVT911Enabled();
  const tf911Conversation =
    useSelectedTextFrom911Conversation(selectedCallerId);

  const selectedVideoRoom = useSelectedVideoRoom(selectedCallerId);

  const isAnyLoading = useMemo(() => {
    if (tf911Conversation) {
      return Object.values(tf911Conversation?.loading).some(value => !!value);
    }
    return false;
  }, [tf911Conversation]);

  useRenewClientToken({
    roomId: selectedVideoRoom?.room_id,
    refreshToken: selectedVideoRoom?.refresh_token,
  });

  const { handleInitVideoSession } = useVideoSessionInitialization({
    isForOverview,
    selectedVideoRoom,
    onStartConversation,
  });

  useEffect(() => {
    // Close the LiveVideoCard whenever selectedCallerID changes
    dispatch(closeCard(LIVE_VIDEO_CARD));
    return () => {
      dispatch(closeCard(LIVE_VIDEO_CARD));
    };
  }, [dispatch, selectedCallerId]);

  if (!isVT911Enabled) {
    return null;
  }

  return (
    <Box width="100%">
      <LiveVideoButton
        btnType="tertiary"
        dataName="legacy-live-video-button"
        disabled={isAnyLoading}
        grow
        noMargin
        onClick={handleInitVideoSession}
        size="med"
        width="100%"
      >
        <MeetingCameraIcon color="secondaryText" height={12} width={12} />
        Live Video
      </LiveVideoButton>
    </Box>
  );
};

export default LiveVideoButtonContainerLegacy;
